import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, ArrowRight, Gift } from "lucide-react";
import { company, navLinks } from "../mock";
import Logo from "./Logo";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <>
      {/* Top bar */}
      <div className="hidden md:block bg-[#081529] text-slate-300 text-[13px]">
        <div className="container-x flex items-center justify-between py-2">
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-2">
              <Phone size={14} className="text-[#D4AF37]" />
              {company.phones[0]}
            </span>
            <span className="opacity-70">{company.address}</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-[#D4AF37] text-[#0B1F3A] px-3 py-1 text-[12px] font-bold tracking-wide" data-testid="topbar-free-consult">
              <Gift size={13} /> {company.freeConsult}
            </span>
            <span className="opacity-70">{company.hours}</span>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <header
        className={`sticky top-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-white/95 backdrop-blur shadow-[0_8px_30px_-12px_rgba(10,26,52,.25)]"
            : "bg-white"
        }`}
      >
        <div className="container-x flex items-center justify-between h-[74px]">
          <Link to="/" className="flex items-center">
            <Logo variant="dark" size={40} />
          </Link>

          <nav className="hidden lg:flex items-center gap-0.5">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-lg text-[14px] font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? "text-[#184E9E]"
                      : "text-slate-700 hover:text-[#0B1F3A]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/pricing-calculator"
              className="btn-gold inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-[15px]"
            >
              Get a Quote <ArrowRight size={16} />
            </Link>
          </div>

          <button
            className="lg:hidden p-2 text-[#0B1F3A]"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden border-t border-slate-100 bg-white">
            <div className="container-x py-4 flex flex-col gap-1">
              {navLinks.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  className={({ isActive }) =>
                    `px-3 py-3 rounded-lg text-base font-medium ${
                      isActive
                        ? "bg-[#F6F7F9] text-[#184E9E]"
                        : "text-slate-700"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/pricing-calculator"
                className="btn-gold text-center mt-2 px-5 py-3 rounded-lg"
              >
                Get a Quote
              </Link>
            </div>
          </div>
        )}
      </header>
    </>
  );
}
